export enum UserRoles {
    SuperAdmin = 1,
    Admin = 2,
    SiteManager = 3,
    Support_Supervisor = 6,
    Support = 7
}
